import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme) {
  var menuStyles = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  };
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    content: _defineProperty({
      padding: "".concat(componentTheme.contentPaddingTopBottom, " ").concat(componentTheme.contentPaddingLeftRight),
      backgroundColor: componentTheme.contentBackgroundColor
    }, mq, {
      padding: "".concat(componentTheme.phoneContentPadding, " 0")
    }),
    breadcrumb: {
      marginBottom: "".concat(componentTheme.breadCrumbMarginBottom)
    },
    topMenu: menuStyles,
    topLeftMenu: _objectSpread(_objectSpread({}, menuStyles), {}, {
      flex: '50%'
    }),
    topRightMenu: _objectSpread(_objectSpread({}, menuStyles), {}, {
      justifyContent: 'flex-end',
      flex: '50%'
    }),
    bankName: {
      padding: "0 0 ".concat(componentTheme.bankNamePaddingBottom, " 0")
    },
    loading: {
      width: '2rem',
      paddingTop: '0.25rem'
    }
  };
};
export default generateStyle;